import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCenterFocusWeak = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.5 14q-.62 0-1.06-.44A1.45 1.45 0 0 1 0 12.5V9.75q0-.319.214-.534A.72.72 0 0 1 .746 9q.316 0 .535.216a.72.72 0 0 1 .219.534v2.75h2.75q.319 0 .534.214a.72.72 0 0 1 .216.532q0 .316-.216.535A.72.72 0 0 1 4.25 14zm11 0H9.75a.73.73 0 0 1-.534-.214.72.72 0 0 1-.216-.532q0-.316.216-.535a.72.72 0 0 1 .534-.219h2.75V9.75q0-.319.214-.534A.72.72 0 0 1 13.246 9q.316 0 .535.216A.72.72 0 0 1 14 9.75v2.75q0 .619-.44 1.06-.442.44-1.06.44M0 4.25V1.5Q0 .88.44.44T1.5 0h2.75q.319 0 .534.214A.72.72 0 0 1 5 .746q0 .316-.216.535a.72.72 0 0 1-.534.219H1.5v2.75q0 .319-.214.534A.72.72 0 0 1 .754 5a.73.73 0 0 1-.535-.216A.72.72 0 0 1 0 4.25m12.5 0V1.5H9.75a.73.73 0 0 1-.534-.214A.72.72 0 0 1 9 .754q0-.316.216-.535A.72.72 0 0 1 9.75 0h2.75q.619 0 1.06.44.44.442.44 1.06v2.75q0 .319-.214.534a.72.72 0 0 1-.532.216.73.73 0 0 1-.535-.216.72.72 0 0 1-.219-.534M7 10a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 4 7q0-1.25.875-2.125A2.9 2.9 0 0 1 7 4q1.25 0 2.125.875T10 7t-.875 2.125A2.9 2.9 0 0 1 7 10m.004-1.5q.621 0 1.059-.442T8.5 6.996t-.442-1.059A1.46 1.46 0 0 0 6.996 5.5q-.621 0-1.059.442A1.46 1.46 0 0 0 5.5 7.004q0 .621.442 1.059t1.062.437"
    />
  </svg>
);
export default SvgCenterFocusWeak;
